import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import PizzaListTabs from "@/components/menu-management/pizza/pizza-list/pizza-list-tabs";
import DraftListTabs from "@/components/menu-management/pizza/pizza-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import {
  fetchAllPizzas,
  clearPizzaMessages,
} from "@/redux/slice/menu-manage-slice/pizza-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import useAuth from "@/hooks/useAuth";
import hasPermission from "@/hooks/hasPermission";

function Pizza() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.pizza
  );

  useEffect(() => {
    dispatch(fetchAllPizzas(user?.restaurant_id));
    dispatch(clearPizzaMessages());
    dispatch(clearItemVariants());
  }, [user?.restaurant_id]);


  if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Pizza List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Pizza", path: "/backoffice/menu/pizza" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
   <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
      
          {hasPermission("back_office.menu_management.create_pizza") && (
            <Link to={"/backoffice/menu/pizza/create"}>
              <Button>
                <Plus /> Create Pizza
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-pizza" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Pizza List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <PizzaListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Pizza;
